// 3rd party
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Button as MuiButton, Divider, Grid, Table, TableCell, TableRow } from "@material-ui/core";

// components
import { Card } from "../../common/card/card";
import { Header } from "../../common/title/header";
import { CardTitle } from ".././workOrderDetails";
import WorkPermitDetails from "./workPermitDetails";
import WorkPermitRowEdit from "./workPermitRowEdit";
import Button from "../../common/button/button";
import { bindActionCreators } from "redux";
import { savePermitInfo } from "../../../redux/task/taskActions";
import { connect } from "react-redux";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import { STATUSES } from "../../../globals/workOrderStatus";

const useStyles = makeStyles({
    errorMsg: {
        color: "red",
    },
});

const WorkPermitInfo = (props) => {
    const classes = useStyles();
    const { relatedIdInformation, edit, onCancel, onEdit } = props;
    const [permits, setPermits] = useState([]);
    const [newRowCount, setNewRowCount] = useState(0);
    const originalPermits = relatedIdInformation?.tasks?.permits?.results;
    const formateDate = (iDate) => (iDate ? moment.utc(iDate).add(-moment().utcOffset(), "minutes").format("YYYY-MM-DD 00:00:00") : "");
    const [requestError, setRequestError] = useState(false);
    const permitDisableEditStatuses = [
        STATUSES.ASSIGNED,
        STATUSES.ENROUTE,
        STATUSES.ONSITE,
        STATUSES.UNASSIGNED,
        STATUSES.PENDING_REVIEW,
        STATUSES.BILLING_ADJUSTMENT,
        STATUSES.RAP_REQUESTED,
        STATUSES.INCOMPLETE,
    ];
    const disabled =
        relatedIdInformation?.tasks?.status === undefined || !permitDisableEditStatuses.includes(relatedIdInformation?.tasks?.status?.id);

    useEffect(() => {
        const skus = originalPermits
            ? originalPermits.map((permit) => {
                  const newPermit = { ...permit };
                  newPermit.requestedDate = formateDate(newPermit.requestedDate);
                  newPermit.receivedDate = formateDate(newPermit.receivedDate);
                  newPermit.expirationDate = formateDate(newPermit.expirationDate);
                  return newPermit;
              })
            : null;
        setPermits(skus);
    }, [originalPermits]);

    const handleCancel = () => {
        setRequestError(false);
        setPermits(originalPermits.map((permit) => ({ ...permit })));
        onCancel();
    };

    const handleAdd = () => {
        setPermits([
            ...permits,
            {
                id: `new-${newRowCount}`,
                permitNumber: null,
                requestedDate: null,
                receivedDate: null,
                expirationDate: null,
                relatedId: relatedIdInformation?.workOrderId,
                remarks: null,
                cost: null,
                invoiceNumber: null,
                new: true,
            },
        ]);
        setNewRowCount(newRowCount + 1);
    };
    const handleDelete = (row, index) => {
        if (row.new) permits.splice(index, 1);
        setPermits([...permits]);
    };
    const onSave = () => {
        setRequestError(false);
        let requestDateIndicator = true;

        if (permits.length > 0) {
            permits.forEach((item) => {
                if (!item.requestedDate) {
                    requestDateIndicator = false;
                }

                if (item.cost) {
                    item.cost = parseFloat(item.cost).toFixed("2");
                }
            });
            var permitInfo = {
                relatedId: relatedIdInformation?.workOrderId,
                permitsRequests: permits.map((permit) => {
                    return {
                        id: !permit.new ? permit.id : null,
                        permitNumber: permit.permitNumber,
                        requestedDate: permit.requestedDate,
                        receivedDate: permit.receivedDate,
                        expirationDate: permit.expirationDate,
                        status: permit.newStatusId ? permit.newStatusId : permit.status?.id,
                        cost: permit.cost,
                        invoiceNumber: permit.invoiceNumber,
                        remarks: permit.remarks,
                        deleteFlag: permit.deleteFlag ? true : false,
                    };
                }),
            };
        }
        if (requestDateIndicator) {
            props.savePermitInfo(permitInfo, relatedIdInformation?.workOrderId, true);
            props.onCancel();
        } else {
            setRequestError(true);
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Header>
                    <FormattedMessage
                        id="admin.work-order-details.wo-info.permits-title"
                        defaultMessage="Permits"
                        description="Admin work order permits title"
                    />
                </Header>
            </Grid>
            <Grid item xs={12}>
                <Card>
                    <CardTitle>
                        <FormattedMessage
                            id="admin.work-order-details.wo-info.permit-details-title"
                            defaultMessage="Permit details"
                            description="Admin work order permit details title"
                        />
                        {edit || (
                            <MuiButton className="no-print" disabled={disabled} onClick={onEdit}>
                                <FormattedMessage
                                    id="admin.work-order-details.edit"
                                    defaultMessage="Edit"
                                    description="Admin work order edit button"
                                />
                            </MuiButton>
                        )}
                    </CardTitle>
                    <div
                        style={{
                            overflowX: "auto",
                        }}>
                        {permits.map((row, index) => {
                            const key = row.id || index;
                            return edit ? (
                                <WorkPermitRowEdit key={key} handleDelete={() => handleDelete(row, index)} row={row} />
                            ) : (
                                <WorkPermitDetails key={key} row={row} />
                            );
                        })}
                    </div>
                </Card>
                {requestError && (
                    <div className={classes.errorMsg}>
                        <FormattedMessage
                            id="admin.work-order-details.work-permit.request-date-error-msg"
                            defaultMessage="Request date is mandatory for work permit entry"
                            description="Request date is mandatory for work permit entry"
                        />
                    </div>
                )}

                {edit && (
                    <Card>
                        <Table>
                            <TableRow>
                                <TableCell align="right">
                                    <Button style={{ paddingRight: "20px" }} tertiary onClick={handleCancel}>
                                        <FormattedMessage
                                            id="admin.work-order-details.permit.cancel-button-caption"
                                            defaultMessage="Cancel"
                                            description="Admin work order permit cancel button caption"
                                        />
                                    </Button>
                                    <Button onClick={onSave} secondary>
                                        <FormattedMessage
                                            id="admin.work-order-details.permit.save-changes-button-caption"
                                            defaultMessage="Save changes"
                                            description="Admin work order permit save button caption"
                                        />
                                    </Button>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align="right" colSpan="5">
                                    <Divider />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align="left" colSpan="5">
                                    <Button onClick={handleAdd} secondary>
                                        <FormattedMessage
                                            id="admin.work-order-details.permit.add-permit-button-caption"
                                            defaultMessage="Add Permit + "
                                            description="Admin work order permit Add permit button caption"
                                        />
                                    </Button>
                                </TableCell>
                            </TableRow>
                        </Table>
                    </Card>
                )}
            </Grid>
        </Grid>
    );
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            savePermitInfo,
        },
        dispatch,
    );

export default connect(null, mapDispatchToProps)(WorkPermitInfo);
